import { render, staticRenderFns } from "./TitleSummaryEditor.vue?vue&type=template&id=0b9fb65b&scoped=true"
import script from "./TitleSummaryEditor.vue?vue&type=script&lang=js"
export * from "./TitleSummaryEditor.vue?vue&type=script&lang=js"
import style0 from "./TitleSummaryEditor.vue?vue&type=style&index=0&id=0b9fb65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9fb65b",
  null
  
)

export default component.exports